import { useParams, useNavigate, Outlet } from "react-router-dom";

import ErrorBoundary from "@/ui/organisms/ErrorBoundary";
import LayoutFullScreen from "@/ui/layouts/LayoutFullScreen";

import {
    ViewEditChartOfAccountsDefinition,
    ViewDatabaseGuard,
    ViewTopBar,
    ViewNewExperienceSection,
    ViewNavigationSidebar,
    ViewEditChartOfAccountsDetails,
} from "@/ui/compositionRootUI";

import {
    chartOfAccountsEditTabsValidator,
    routerPaths,
} from "@/ui/router/routerPaths";
import GridLoader from "@/ui/molecules/GridLoader";
import { useEffect } from "react";

const VIEW_EDIT_CHART_OF_ACCOUNTS_ACTION_BAR_HEIGHT = 100;

const PageEditChartOfAccounts = () => {
    const navigate = useNavigate();

    const { coaId, tab } = useParams() as {
        coaId: string;
        tab: string;
    };

    const navigateToDashboard = () => {
        navigate(routerPaths.chartsOfAccounts.dashboard("list"));
    };

    useEffect(() => {
        const isValidTab = chartOfAccountsEditTabsValidator(tab);
        if (isValidTab) return;
        if (!coaId) return;
        navigate(routerPaths.chartsOfAccounts.editCoA(coaId, "details"));
    }, [navigate, tab, coaId]);

    return (
        <LayoutFullScreen
            TopBarProps={{
                sx: {
                    backgroundColor: "var(--proda-white-110)",
                },
                onLogoClick: () => navigate(routerPaths.main.default()),
            }}
            MainContentProps={{
                sx: {
                    backgroundColor: "var(--proda-white)",
                    borderTop: "1px solid var(--primary-color)",
                },
            }}
            contentTopBar={<ViewTopBar />}
            contentTopBarBanner={<ViewNewExperienceSection />}
            contentSidebar={<ViewNavigationSidebar />}
        >
            <ErrorBoundary>
                <ViewDatabaseGuard
                    loader={
                        <GridLoader
                            sx={{
                                paddingTop: `${VIEW_EDIT_CHART_OF_ACCOUNTS_ACTION_BAR_HEIGHT}px`,
                            }}
                        />
                    }
                >
                    {chartOfAccountsEditTabsValidator(tab) &&
                        (tab === "definition" ? (
                            <ViewEditChartOfAccountsDefinition
                                coaId={Number(coaId)}
                                navigateToDashboard={navigateToDashboard}
                            />
                        ) : (
                            <ViewEditChartOfAccountsDetails
                                coaId={Number(coaId)}
                                onClickBackButton={navigateToDashboard}
                            />
                        ))}
                </ViewDatabaseGuard>
                <Outlet />
            </ErrorBoundary>
        </LayoutFullScreen>
    );
};

export default PageEditChartOfAccounts;
